"use client";

import React from "react";
import { CheckCircle2 } from "lucide-react";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
type Block = {
  id: string;
  title: string;
  content: string;
  type: "normal" | "blockquote";
};
type ListItem = {
  id: number;
  blockId: string;
  text: string;
};
const blocks: Block[] = [{
  id: "overview",
  title: "Overview",
  content: "This project involved the full renovation of a private residence located in the Agios Nikolaos area of Limassol. The objective was to modernise the entire property and create a refined living environment that combines functionality, comfort, and contemporary design.",
  type: "normal"
}, {
  id: "challenge",
  title: "The Challenge",
  content: "The existing property required a complete interior transformation to improve both layout efficiency and visual harmony. The renovation needed to deliver a modern aesthetic while maintaining practicality for everyday living.",
  type: "normal"
}, {
  id: "approach",
  title: "Our Approach",
  content: "The project included a comprehensive full house renovation, covering interior upgrades, structural improvements, and the implementation of high-quality finishes throughout the home. Every stage of the process was carefully coordinated to ensure a smooth and efficient renovation timeline.",
  type: "normal"
}, {
  id: "result",
  title: "The Result",
  content: "Within three months, the residence was fully transformed into a modern and elegant living space. The renovation significantly enhanced the home's functionality, aesthetic appeal, and overall property value.",
  type: "normal"
}];
const approachList: ListItem[] = [{
  id: 1,
  blockId: "approach",
  text: "Comprehensive system audit and bottleneck identification."
}, {
  id: 2,
  blockId: "approach",
  text: "Phased migration strategy with zero planned downtime."
}, {
  id: 3,
  blockId: "approach",
  text: "Implementation of robust security protocols."
}];
function ContentBlock({
  block,
  index
}: {
  block: Block;
  index: number;
}) {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <div ref={ref} data-index={index} className={`transition-all duration-700 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
      <h2 className="font-display text-3xl md:text-4xl font-bold text-foreground mb-6">
        {block.title}
      </h2>

      {block.type === "blockquote" ? <blockquote className="border-l-4 border-border pl-6 py-2 my-8 italic font-sans text-lg md:text-xl text-foreground/90">
          <p className="leading-relaxed">{block.content}</p>
        </blockquote> : <p className="font-sans text-base md:text-lg text-foreground leading-relaxed mb-6">
          {block.content}
        </p>}

    </div>;
}
export default function MainContent() {
  return <section id="main-content" className="bg-background ![padding:40px_32px_96px_0px]">
      <div className="max-w-7xl mx-auto grid grid-cols-1 md:grid-cols-2 gap-x-12 gap-y-16 px-6 md:px-8">
        {blocks.map((block, i) => <ContentBlock key={block.id} block={block} index={i} />)}

         <div className="mt-2 flex justify-start">
          <Link to="https://ksluxury.cloudtech.com.cy/projects/" className="btn-primary">
            Back to Projects
          </Link>
        </div>
      </div>


    
    </section>;
}